import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const DEFAULT_TITLE = "More than one medical carrier";

/**
 * Shown when a client's carrier feature keys forbid submitting the model as it
 * stands - the plain "aetna" one-carrier rule, or one of the paired-carrier
 * rules (aetna-uhc, aetna-oxford).
 *
 * `message` comes from the server verdict, which knows which rule applied and
 * which carrier is permitted alongside. It falls back to the original
 * single-carrier copy so the aetna-only case reads exactly as it did before.
 *
 * There is deliberately no way to proceed from here - the only action closes the
 * dialog and returns the user to the model so they can remove a carrier.
 */
const MultipleMedicalCarriersDialog = ({
  carrierNames,
  title,
  message,
  onClose,
}) => {
  // Deduped: two carrier ids can share a display name, which would otherwise
  // render the same name twice under a duplicate React key.
  const names = [...new Set((carrierNames ?? []).filter(Boolean))];

  return (
    <Dialog title={title || DEFAULT_TITLE} onClose={onClose} width={520}>
      <div style={{ padding: "10px 15px" }}>
        {message ? (
          <p>{message}</p>
        ) : (
          <p>
            This model cannot be submitted because it contains more than one
            medical carrier. Only <b>one</b> medical carrier is allowed per
            submitted model.
          </p>
        )}

        {names.length > 0 && (
          <>
            <p style={{ marginBottom: 4 }}>
              Medical carriers currently in this model:
            </p>
            <ul style={{ marginTop: 0 }}>
              {names.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          </>
        )}

        <p>
          Please go back and remove a medical carrier, then submit again.
        </p>
      </div>
      <DialogActionsBar layout={"end"}>
        <Button themeColor={"primary"} onClick={onClose}>
          {"Back to Model"}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default MultipleMedicalCarriersDialog;
